import { TextField } from '@mui/material'
import { useEffect,useState,useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { post } from '../../utils/axios'
import Button from '../../components/Button'
import { toast } from 'react-toastify'
import { Context } from '../../context/Context'

const Verify = () => {

    const navigate = useNavigate()
    const context = useContext(Context)
    
    const [phone,setPhone] = useState(localStorage.getItem('phone'))
    const [username,setUsername] = useState(localStorage.getItem('username'))
    const [supportPhone,setSupportPhone] = useState('')
    const [isLoading,setIsLoading] = useState(false)
    const [code,setCode] = useState('')
    const [code1,setCode1] = useState('')
    const [code2,setCode2] = useState('')
    const [code3,setCode3] = useState('')
    const [code4,setCode4] = useState('')
    const [code5,setCode5] = useState('')
    const [counter,setCounter] = useState(120)

    const startCounter = () => {
        setCounter(120)
        let interCounter = 120
        const interval = setInterval(() => {
            if(interCounter > 0){
                interCounter -= 1
                setCounter(interCounter)
            }
            if(interCounter == 0)
                clearInterval(interval)
        },1000)
    }

    const sendAgain = async () => {
        const postedData = {
            username
        }
        const { data } = await post('User/LoginUser',postedData)
        if(data.isSuccess){
            toast.success('کد اعتبارسنجی به شماره همراه شما ارسال شد')
            startCounter()
        }else
            toast.error(data.message)
    }

    useEffect(() => {
        localStorage.removeItem('phone')
        localStorage.removeItem('username')
        if(!phone || !username)
            return navigate('/')
        const postedData = {
            key: 'support_phone'
        }
        post('Config/GetConfigByKey',postedData).then(({data}) => {
            if(data.isSuccess)
                setSupportPhone(data.data.value)
        })
        startCounter()
    },[])

    const persianNumbers = ['۰','۱','۲','۳','۴','۵','۶','۷','۸','۹']

    const changeToEnglish = (number,method) => {
        if(number.includes('۰'))
            method('0')
        if(number.includes('۱'))
            method('1')
        if(number.includes('۲'))
            method('2')
        if(number.includes('۳'))
            method('3')
        if(number.includes('۴'))
            method('4')
        if(number.includes('۵'))
            method('5')
        if(number.includes('۶'))
            method('6')
        if(number.includes('۷'))
            method('7')
        if(number.includes('۸'))
            method('8')
        if(number.includes('۹'))
            method('9')
    }

    useEffect(() => {
        if(persianNumbers.includes(code1))
            changeToEnglish(code1,setCode1)
        if(persianNumbers.includes(code2))
            changeToEnglish(code2,setCode2)
        if(persianNumbers.includes(code3))
            changeToEnglish(code3,setCode3)
        if(persianNumbers.includes(code4))
            changeToEnglish(code4,setCode4)
        if(persianNumbers.includes(code5))
            changeToEnglish(code5,setCode5)
        setCode(code1.toString() + code2.toString() + code3.toString() + code4.toString() + code5.toString()) 
    },[code1,code2,code3,code4,code5])

    useEffect(() => {
        if(code.length == 5)
            verify()
    },[code])

    const verify = async e => {
        setIsLoading(true)
        const postedData = {
            username,
            otpCode: code
        }
        post('User/VerifyLoginUser',postedData).then(({data}) => {
            if(data.isSuccess){
                context.setBasket([])
                context.setGuildId(0)
                context.setCurrentProvinceId(0)
                context.setCurrentCityId(0)
                context.setAddress({})
                localStorage.setItem('token',data.data.token)
                setTimeout(() => {
                    navigate('/app')
                },300)
            }else
                toast.error(data.message)
        }).finally(() => {
            setIsLoading(false)
        })
    }

    const getCodeFromSms = otp => {
        otp = otp.toString()
        setCode1(otp[0])
        setCode2(otp[1])
        setCode3(otp[2])
        setCode4(otp[3])
        setCode5(otp[4])
    }

    useEffect(() => {
        if('OTPCredential' in window){ 
            const ac = new AbortController();
            navigator.credentials.get({
                otp: { transport:['sms'] },
                signal: ac.signal
            }).then(otp => {
                if(otp.code)
                    getCodeFromSms(otp.code)
            });
        }
    },[])

    const goToNextInput = (e,inputId) => {
        const key = e.keyCode || e.charCode
        if(key == 8 || key == 46){
            if(inputId != 1)
                document.getElementById(`otp-${inputId - 1}`).focus()
        }else{
            if(inputId != 5 && e.target.value.length === 1)
                document.getElementById(`otp-${inputId + 1}`).focus()
        }
    }

    const prevent = e => {
        const key = parseInt(e.key)
        const keyCode = e.keyCode || e.charCode
        if(!/^\d+$/.test(key) && keyCode != 8 && keyCode != 46)
            e.preventDefault()
    }

    return (
        <form className="auth-container" onSubmit={e => verify(e)}>
            <h2 className="auth-page-title">اعتبارسنجی</h2>
            <input type="hidden" inputMode="numeric" pattern="\d{5}" autoComplete="one-time-code" onChange={e => getCodeFromSms(e.target.value)} />
            <div className="auth-input-group" dir="ltr">
                <TextField type="tel" autoFocus={true} hiddenLabel sx={{width: '17%'}} inputProps={{maxLength: 1,id: 'otp-1'}} onKeyDown={e => prevent(e)} onKeyUp={e => goToNextInput(e,1)} value={code1} onChange={e => setCode1(e.target.value)} />
                <TextField type="tel" hiddenLabel sx={{width: '17%'}} inputProps={{maxLength: 1,id: 'otp-2'}} onKeyDown={e => prevent(e)} onKeyUp={e => goToNextInput(e,2)} value={code2} onChange={e => setCode2(e.target.value)} />
                <TextField type="tel" hiddenLabel sx={{width: '17%'}} inputProps={{maxLength: 1,id: 'otp-3'}} onKeyDown={e => prevent(e)} onKeyUp={e => goToNextInput(e,3)} value={code3} onChange={e => setCode3(e.target.value)} />
                <TextField type="tel" hiddenLabel sx={{width: '17%'}} inputProps={{maxLength: 1,id: 'otp-4'}} onKeyDown={e => prevent(e)} onKeyUp={e => goToNextInput(e,4)} value={code4} onChange={e => setCode4(e.target.value)} />
                <TextField type="tel" hiddenLabel sx={{width: '17%'}} inputProps={{maxLength: 1,id: 'otp-5'}} onKeyDown={e => prevent(e)} onKeyUp={e => goToNextInput(e,5)} value={code5} onChange={e => setCode5(e.target.value)} />
            </div>
            <Button isLoading={isLoading} type="submit" fullWidth={true} sx={{mt: 3,py: 1.5}} className="custom-btn-primary" variant="contained" onClick={verify}>تایید</Button>
            <p className="auth-page-footer">کد اعتبارسنجی به شماره <span className="text-blue">{phone}</span> ارسال شد <span style={{color: '#000'}} onClick={() => navigate(-1)}>تغییر شماره</span></p>
            {counter != 0 ? <p className="auth-page-footer">{counter} ثانیه تا ارسال مجدد</p> : <p className="auth-page-footer cursor-pointer text-blue" onClick={sendAgain}>ارسال مجدد</p>}
            <p className="auth-page-footer">به شماره <span className="text-blue">{phone}</span> دسترسی ندارید؟ <a className="text-red cursor-pointer" href={`tel:${supportPhone}`}>تماس با پشتیبانی</a></p>
        </form>
    )
}

export default Verify